import { AccountDoc } from 'types/api/changes'
import { highestActiveTier } from './api/accounts'
import { isFeatureAllowedToUser } from './api/groups'
import { TierFeatures } from './api/group_state'
import { DocPhoneNumberType } from './auth'
import LocalStorage from 'services/LocalStorage'
import { LocalStorageKey } from 'types/services/localStorage'

export function isUserOutOfTierBasedOnLandline(accountDoc?: AccountDoc) {
  return (
    !isFeatureAllowedToUser(
      TierFeatures.LANDLINE,
      highestActiveTier(accountDoc),
      undefined,
      accountDoc
    ) &&
    accountDoc?.PhoneNumberType === DocPhoneNumberType.LANDLINE &&
    LocalStorage.get(LocalStorageKey.PHONE_NUMBER_TYPE) ===
      DocPhoneNumberType.LANDLINE
  )
}

export function outOfTiersFeaturesForAccount(accountDoc?: AccountDoc) {
  if (!accountDoc) return []

  const outOfTierFeatures: TierFeatures[] = []
  const currentTier = highestActiveTier(accountDoc)
  if (
    !isFeatureAllowedToUser(
      TierFeatures.LANDLINE,
      currentTier,
      undefined,
      accountDoc
    )
  )
    outOfTierFeatures.push(TierFeatures.LANDLINE)

  return outOfTierFeatures
}
